import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { DashboardModule } from './components/dashboard/dashboard.module';
import { SharedModule } from './shared/shared.module';
import { ProductsModule } from './components/products/products.module';
import { SalesModule } from './components/sales/sales.module';
import { CouponsModule } from './components/coupons/coupons.module';
import { PagesModule } from './components/pages/pages.module';
import { MediaModule } from './components/media/media.module';
import { MenusModule } from './components/menus/menus.module';
import { VendorsModule } from './components/vendors/vendors.module';
import { UsersModule } from './components/users/users.module';
import { LocalizationModule } from './components/localization/localization.module';
import { InvoiceModule } from './components/invoice/invoice.module';
import { SettingModule } from './components/setting/setting.module';
import { OnlinestoresModule } from './components/onlinestores/onlinestores.module';
import { AuthModule } from './components/auth/auth.module';
import { AuthService } from './services/auth.service';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { onlinestores } from './components/onlinestores/onlinestores.service';
import { DataTablesModule } from 'angular-datatables';
import { StoresComponent } from './components/products/physical/stores/stores.component';
import { TelegramModule } from './components/telegram/telegram.module';
@NgModule({
  declarations: [
    AppComponent,
  

  ],
  imports: [
    BrowserAnimationsModule,
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    AppRoutingModule,
    DashboardModule,
    OnlinestoresModule,
    DataTablesModule,
    InvoiceModule,
    SettingModule,
    AuthModule,
    SharedModule,
    LocalizationModule,
    // ProductsModule,
    SalesModule,
    VendorsModule,
    HttpClientModule,
    CouponsModule,
     PagesModule,
    MediaModule,
    MenusModule,
    UsersModule,
   // AgGridModule,
    FormsModule,
    TelegramModule,

  ],
  providers: [AuthService, onlinestores],
  bootstrap: [AppComponent]
})
export class AppModule { }
